import APIKit from './apiFactory'

export type AdminCreateUserPayload = {
  email: string
  first_name: string
  last_name: string
  subscription?: 'trial' | 'free' | 'pro' | 'lifetime'
}

export const createUser = async (payload: AdminCreateUserPayload) => {
  const res = await APIKit.post('/api/admin/users', payload)
  return res?.data
}
